import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-dropdown-section',
  templateUrl: './table-dropdown-section.component.html',
  styleUrls: ['./table-dropdown-section.component.css']
})
export class TableDropdownSectionComponent {
  isOpen = true;
}
